import { QueryStatus } from '@models/queryStatus';
import { Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import { LoginView } from '@pages/Login/constants';
import { useSearchQuoteSetupPreset } from '@services/quotes';
import { useNavigate } from 'react-router-dom';

export const QuoteSetupPresetWelcomeMessage = ({
  view,
  redirectUrl,
  onInvalidSlug,
}: {
  view?: LoginView;
  redirectUrl: string;
  onInvalidSlug: () => void;
}) => {
  const navigate = useNavigate();

  let queryString = redirectUrl.split('?')[1];
  let searchParams = new URLSearchParams(queryString);
  const slug = searchParams.get('preset') ?? undefined;

  const { quotePresets, isFetching, status } = useSearchQuoteSetupPreset({ slug }, !!slug);

  if (isFetching) {
    return null;
  }

  if (status === QueryStatus.Error || (!isFetching && !quotePresets?.length)) {
    onInvalidSlug();
    return null;
  }

  const slugInfo = quotePresets?.[0];
  const brokerageName = slugInfo?.brokerage.name;
  const offeringLabel = slugInfo?.offering?.label ?? slugInfo.offering.insuranceProduct.name;

  return (
    <Box sx={{ maxWidth: 430 }}>
      <Typography
        variant='h3'
        sx={{
          fontWeight: 600,
          mb: 1,
        }}
      >
        Welcome! Thank you for your interest in a {offeringLabel} quote today.
      </Typography>

      {view !== LoginView.SIGNUP ? (
        <Typography variant='body' mt={2}>
          To continue your quote through{' '}
          <Box fontWeight='bold' component='span'>
            {brokerageName}
          </Box>
          , please sign in with your LIO account, or{' '}
          <Button
            color='secondary'
            variant='text'
            disableRipple
            onClick={() => {
              navigate('/sign-up');
            }}
            sx={sxStyles.inlineButton}
          >
            create an account
          </Button>{' '}
          if you aren{`'`}t registered.
        </Typography>
      ) : (
        <Typography variant='body' mt={2}>
          To get started with your quote through{' '}
          <Box fontWeight='bold' component='span'>
            {brokerageName}
          </Box>
          , please create a LIO account, or{' '}
          <Button
            color='secondary'
            variant='text'
            disableRipple
            onClick={() => {
              navigate('/login');
            }}
            sx={sxStyles.inlineButton}
          >
            sign in
          </Button>{' '}
          if you are already registered.
        </Typography>
      )}
    </Box>
  );
};

const sxStyles = {
  inlineButton: {
    fontSize: 'inherit',
    margin: 0,
    padding: 0,
    mt: '-2px',
    display: 'inline',
  },
};
